import type { JSX } from 'react';
import { Box, TableHeader, Text } from '@ksyos/design-system';
import { useTheme } from 'styled-components';

type OutclinicDashboardTableColumnHeaderProps = Readonly<{
    colSpan?: number;
    hasSolidBorder?: boolean;
    label?: string;
}>;

export function OutclinicDashboardTableColumnHeader(props: OutclinicDashboardTableColumnHeaderProps): JSX.Element {
    const theme = useTheme();

    const headerBorderBottom = `1px solid ${theme.colors.neutral300}`;
    const headerStyles = props.colSpan
        ? {
              '> div': {
                  paddingBottom: 0,
              },
              fontWeight: theme.fontWeights.medium,
          }
        : {
              borderBottom: headerBorderBottom,
          };

    return (
        <TableHeader
            colSpan={props.colSpan}
            sx={{
                ...headerStyles,
                position: 'relative',
            }}
        >
            <Text
                fontWeight={props.colSpan ? 'medium' : 'normal'}
                size="xs"
            >
                {props.label}
            </Text>
            {!props.colSpan && (
                <Box
                    backgroundColor={props.hasSolidBorder ? 'neutral300' : 'neutral100'}
                    height="50000px"
                    position="absolute"
                    right="0"
                    top={props.hasSolidBorder ? '-50px' : '50px'}
                    width="1px"
                />
            )}
        </TableHeader>
    );
}
